<template>
  <div class="spe-count-down-wrap" v-if="timeData.isShow" :style="{ bottom: countDownBottom + 'rem' }">
        <div class="content">
            <template v-if="timeData.days > 0">
                <div class="text">{{timeData.text}}</div>
                <div class="time-common">{{timeData.days}}</div>
                <div>天</div>
                <div class="time-common">{{timeData.hours}}</div>
                <div>小时</div>
                <div class="time-common">{{timeData.minutes}}</div>
                <div>分</div>
            </template>
            <template v-else>
                <div class="text">{{timeData.text}}</div>
                <div class="time-common"> {{timeData.hours}} : {{timeData.minutes}} : {{timeData.seconds}}</div>
            </template>
        </div>
	</div>
</template>

<script>
export default {
	props: {
        // 倒计时类型，0为小于24小时，1为大于24小时
        json: {
            type: Object,
            default() {
                return {}
            }
        },
        posInfo: {
            type:Object,
            default: () => {
                return {}
            }
        },
        isMina: {
            type: Boolean,
            default: false
        },
        isIos: {
            type: Boolean,
            default: false
        },
        isAndroid: {
            type: Boolean,
            default: false
        }
	},
	components: {},
	data() {
		return {
            type: 1, // 时间显示类型：小于24小时为1，大于24小时为2
            timeData: {
                time: 0,
                isShow: false,
                text: '',
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            timer: null
        };
	},
    computed: {
        countDownBottom () {
            let { bottomTab, countDown, toTop } = this.posInfo
             const data = this.isIos && this.isMina ? 0.68 : 0
            if (bottomTab) {
                return 1.04 + data
            } else {
                return 0.04 + data
            }
        }
    },
    watch: {
        json: {
            handler(newVal, oldVal) {
                let { data } = newVal
                this.timeData.time = data && data.time
                this.timeData.text = data && data.content
                this.timer = setInterval(this.setTime, 1000)
                this.$emit('setCountDown', true)
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        setTime() {
            let time = this.timeData.time
            if(!time || time < 0) {
                this.timeData.isShow = false
                clearInterval(this.timer)
                this.$emit('setCountDown', false)
                return 
            }
            let hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
            let minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60))
            let seconds = parseInt((time % (1000 * 60)) / 1000) 
            this.timeData.isShow = true
            this.timeData.days =  parseInt(time / (1000 * 60 * 60 * 24))
            this.timeData.hours = hours < 10 ? '0' + hours : hours
            this.timeData.minutes = minutes < 10 ? '0' + minutes : minutes
            this.timeData.seconds = seconds < 10 ? '0' + seconds : seconds
            this.timeData.time = time - 1000
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-count-down-wrap {
    position: fixed;
    z-index: 90;
    left: 50%;
    transform: translateX(-50%);
    .content {
        height: 64px;
        background: rgba(0,0,0,0.80);
        border-radius: 45px;
        color: #ffffff;
        text-align: center;
        padding: 0px 30px;
        display: flex;
        white-space: nowrap;
        align-items: center;
        .text {
            margin-right: 10px;
            font-weight: 600;
        }
        .time-common {
            font-size: 28px;
            color: #FFEE41;
            font-weight: 600;
        }
    }
}
</style>
